import { EventAggregator } from 'aurelia-event-aggregator';
import {
	autoinject,
	bindable,
	BindingEngine,
	bindingMode,
	computedFrom,
	customElement,
	PLATFORM,
	useView,
} from 'aurelia-framework';

import { SuburbLoaderApi } from '~/api/suburb-loader-api';
import { AutocompleteColumnHeader } from '~/components/field/common/autocomplete/autocomplete-react';
import { Country } from '~/components/field/common/country';
import { Field } from '~/components/field/common/field';
import { Form } from '~/components/form/form';
import {
	SuburbAutocompleteItem,
	SuburbAutocompleteItemFields,
} from '~/models/suburb';

@autoinject
@customElement('a-suburb')
@useView(PLATFORM.moduleName('./suburb.html'))
export class Suburb extends Field {
	private readonly columnHeaders: AutocompleteColumnHeader[] = [
		{
			columnName: SuburbAutocompleteItemFields.PCz_Place_Name,
			display: 'Place Name',
		},
		{
			columnName: SuburbAutocompleteItemFields.PCz_State,
			display: 'State',
		},
		{
			columnName: SuburbAutocompleteItemFields.PCz_Post_Code,
			display: 'Postcode',
		},
	];

	private isSuburbsLoading: boolean = false;

	private readonly itemColumnName =
		SuburbAutocompleteItemFields.PCz_Place_Name;

	@bindable({
		defaultBindingMode: bindingMode.oneWay,
	})
	private readonly stateField: Field;

	@bindable({
		defaultBindingMode: bindingMode.oneWay,
	})
	private readonly postcodeField: Field;

	@bindable({
		defaultBindingMode: bindingMode.oneWay,
	})
	private readonly countryField: Country;

	constructor(
		private loaderApi: SuburbLoaderApi,
		public element: Element,
		protected parentForm: Form,
		protected bindingEngine: BindingEngine,
		readonly eventAggregator: EventAggregator,
	) {
		super(Field.TYPE.SUBURB, element, parentForm, eventAggregator);
		this.isDisableInputMasks = true;
	}

	private readonly onSelect = (record: SuburbAutocompleteItem): void => {
		if (record) {
			if (this.postcodeField && record.PCz_Post_Code) {
				this.postcodeField.value = record.PCz_Post_Code;
			}
			if (this.stateField && record.PCz_State) {
				this.stateField.value = record.PCz_State;
			}
		}

		if (this.countryField && !this.countryField.value) {
			this.countryField.value = 'AU';
		}
	};

	@computedFrom('countryField.value')
	get remotePromise(): SuburbLoaderApi | undefined {
		if (this.countryField && this.countryField.isBlankOrAustralia()) {
			return this.loaderApi;
		}
		return undefined;
	}
}
